import ReactGA from "react-ga4";

const initGa4 = () => {
    const GA4_KEY = process.env.MIX_GOOGLE_ANALYTICS_4_KEY
    if (GA4_KEY) {
        ReactGA.initialize(GA4_KEY);
        ReactGA.send("pageview");
    }
}

export default initGa4;
